import { Dropdown as Dropdown$1 } from './Dropdown.js';
export { StatelessDropdown, useDropdownState } from './Dropdown.js';
import './Item/index.js';
import './Divider/index.js';
import './Header/index.js';
import { DropdownChevron } from './DropdownChevron.js';
import { DropdownChevrons } from './DropdownChevrons.js';
import { DropdownItemDescription } from './DropdownItemDescription.js';
import { DropdownDownload } from './DropdownDownload.js';
import { DropdownSkeleton } from './DropdownSkeleton.js';
import './EllipsisDropdownAction/index.js';
export { CardDropdown, DropdownButton, showDropdownStyles } from './CardDropdown.js';
import { DropdownItem, DropdownItemAnchor, DropdownItemNavLink } from './Item/DropdownItem.js';
export { DropdownItem } from './Item/DropdownItem.js';
import { DropdownShortcutText } from './Item/DropdownItem.styles.js';
export { DropdownItemStyle, dropdownItemStyles } from './Item/DropdownItem.styles.js';
import { DropdownDivider } from './Divider/DropdownDivider.js';
export { dropdownDividerStyles } from './Divider/DropdownDivider.js';
import { DropdownHeader } from './Header/DropdownHeader.js';
export { DropdownHeader } from './Header/DropdownHeader.js';
export { DropdownAction, EllipsisDropdownAction } from './EllipsisDropdownAction/EllipsisDropdownAction.js';

const Item = Object.assign(DropdownItem, {
    Anchor: DropdownItemAnchor,
    NavLink: DropdownItemNavLink,
    ShortcutText: DropdownShortcutText,
});
const Dropdown = Object.assign(Dropdown$1, {
    Item,
    ItemDescription: DropdownItemDescription,
    Download: DropdownDownload,
    Divider: DropdownDivider,
    Header: DropdownHeader,
    Chevron: DropdownChevron,
    Chevrons: DropdownChevrons,
    Skeleton: DropdownSkeleton,
});

export { Dropdown };
